export default {
  methods: {
    // Pass in all keys in query param that want to be filtered
    filterQueryParams(...restArgs) {
      const query = { ...this.$route.query }
      restArgs.forEach((arg) => delete query[arg])
      return query
    },

    normalizeAccentedProductName(product) {
      return product
        .normalize('NFD')
        .replace(/[\u0300-\u036F]/g, '')
        .toLowerCase()
    },

    updateStoreTypeFilterParams(routeQuery, filterTypes) {
      const filterTypeParams = filterTypes.reduce((object, filterType) => {
        const routeFilterValues = routeQuery[filterType.slugUrl]
          ? routeQuery[filterType.slugUrl].split(',')
          : []

        // Removing invalid filter values
        const filterValueSlugs = filterType.filterValues.map(
          (value) => value.slugUrl
        )
        object[filterType.slugUrl] = routeFilterValues.filter((value) =>
          filterValueSlugs.includes(value)
        )

        return object
      }, {})

      this.$store.commit(
        'listingPageFilters/setListingPageTypeFilterParams',
        filterTypeParams
      )
    },

    updateStoreOtherFilterParams(routeQuery, otherFilters) {
      const othersQueries = routeQuery.others
        ? routeQuery.others.split(',')
        : []

      if (othersQueries.length > 0) {
        const selectedOtherFilters = []

        for (const otherQuery of othersQueries) {
          const validFilter = otherFilters.find(
            (filter) => filter.slugUrl === otherQuery
          )
          if (validFilter) {
            selectedOtherFilters.push(validFilter.slugUrl)
          }
        }

        if (selectedOtherFilters.length) {
          this.$store.commit(
            'listingPageFilters/setListingPageOtherFilterParams',
            selectedOtherFilters
          )
          return
        }
      }

      // Clears store when router.push() without Others query
      this.$store.commit(
        'listingPageFilters/setListingPageOtherFilterParams',
        []
      )
    },

    updateStoreBrandFilterParams(routeQuery, brandFilters) {
      const brandQueries = routeQuery.brands ? routeQuery.brands.split(',') : []

      if (brandQueries.length) {
        const selectedBrands = []

        for (const brandQuery of brandQueries) {
          const validFilter = brandFilters.find(
            (filter) => filter.slugUrl === brandQuery
          )
          if (validFilter) {
            selectedBrands.push(validFilter.slugUrl)
          }
        }

        if (selectedBrands.length) {
          this.$store.commit(
            'listingPageFilters/setListingPageBrandFilterParams',
            selectedBrands
          )
          return
        }
      }

      // Clears store when router.push() without Brands query
      this.$store.commit(
        'listingPageFilters/setListingPageBrandFilterParams',
        []
      )
    }
  }
}
